import type { InjectionKey } from 'vue'

export const EDITOR_TEXTS_SAVED: InjectionKey<() => void> = Symbol('editorTextsSaved')
